import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/mastercard.png'
import _imports_1 from '@/assets/img/visa.png'
import _imports_2 from '@/assets/img/jcb.png'
import _imports_3 from '@/assets/img/firstchoice.png'
import _imports_4 from '@/assets/img/ktc.png'
import _imports_5 from '@/assets/img/krungsri.png'
import _imports_6 from '@/assets/img/Icon_1.svg'
import _imports_7 from '@/assets/img/Icon_2.svg'
import _imports_8 from '@/assets/img/icon_3.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-082a132d")

_pushScopeId("data-v-082a132d")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "container h-100 w-100 d-flex align-items-center justify-content-center" }
const _hoisted_3 = { class: "row h-75 w-100 justify-content-between" }
const _hoisted_4 = { class: "col-12 col-md-6 mt-3 d-flex flex-column justify-content-center align-items-center align-items-md-start" }
const _hoisted_5 = {
  class: "text-primary display-4 fw-bold",
  style: {"font-size":"38px"}
}
const _hoisted_6 = { class: "display-4 fw-bold" }
const _hoisted_7 = {
  class: "pt-3 fw-normal",
  style: {"font-size":"18px","line-height":"26px"}
}
const _hoisted_8 = { class: "productPageHeader__img mt-sm-5 col-12 col-md-6 col-lg-6 d-flex flex-column justify-content-start justify-content-md-center align-items-start position-relative overflow-hidden" }
const _hoisted_9 = {
  key: 0,
  class: "row h-auto w-100 d-flex justify-content-center",
  style: {"animation-duration":"1s"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "productHeader__cell d-flex justify-content-center align-items-center" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "productHeader__cell d-flex justify-content-center align-items-center productHeader__cell--faded" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow homeImage-c1" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "row h-auto w-100 d-flex justify-content-center",
  style: {"animation-duration":"1.3s"}
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "productHeader__cell d-flex justify-content-center align-items-center productHeader__cell--faded" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow homeImage-c2",
  style: {"animation-delay":"0.4s"}
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "placeholder__cell" }, null, -1)
const _hoisted_17 = {
  key: 2,
  class: "row h-auto w-100 d-flex justify-content-center",
  style: {"animation-duration":"1.5s"}
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", {
  class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow homeImage-c3",
  style: {"animation-delay":"0.8s"}
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "placeholder__cell" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "placeholder__cell" }, null, -1)
const _hoisted_21 = { class: "productPageContent" }
const _hoisted_22 = { class: "container pb-5" }
const _hoisted_23 = { class: "row d-flex justify-content-between px-5" }
const _hoisted_24 = { class: "col-12 col-md-5" }
const _hoisted_25 = { class: "d-flex flex-column align-items-center text-center align-items-md-start text-md-start" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "product-icon d-flex justify-content-center align-items-center rounded-circle my-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-cash-coin display-5 text-primary" })
], -1)
const _hoisted_27 = { class: "my-3" }
const _hoisted_28 = { class: "lh-base" }
const _hoisted_29 = { class: "col-12 col-md-5 mt-5 mt-md-0" }
const _hoisted_30 = { class: "d-flex flex-column align-items-center text-center align-items-md-start text-md-start" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "product-icon my-3 d-flex justify-content-center align-items-center rounded-circle" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-lightning-charge-fill display-5 text-primary" })
], -1)
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_34 = { class: "lh-base" }
const _hoisted_35 = { class: "container mt-5 pt-0 pt-md-5 product-section" }
const _hoisted_36 = { class: "row h-100 justify-content-between px-5" }
const _hoisted_37 = { class: "col-12 h-100 col-md-6 mt-3 d-flex flex-column justify-content-center align-items-center text-center align-items-md-start text-md-start" }
const _hoisted_38 = {
  class: "display-4 fw-normal",
  style: {"font-size":"38px"}
}
const _hoisted_39 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_40 = {
  class: "my-5 fw-normal",
  style: {"font-size":"18px","line-height":"28px","letter-spacing":"-0.25px"}
}
const _hoisted_41 = {
  class: "col-12 d-none d-sm-flex col-md-6 d-flex flex-column justify-content-center position-relative overflow-hidden",
  ref: "s2"
}
const _hoisted_42 = {
  key: 0,
  class: "row justify-content-end",
  style: {"animation-duration":"1s"}
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", {
  class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow installmentImage-c1",
  style: {"animation-delay":"0.2s"}
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_44 = {
  key: 1,
  class: "row h-auto justify-content-center",
  style: {"animation-duration":"1.3s"}
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", {
  class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow installmentImage-c2",
  style: {"animation-delay":"0.4s"}
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_4,
    alt: ""
  })
], -1)
const _hoisted_46 = {
  key: 2,
  class: "row h-auto justify-content-start",
  style: {"animation-duration":"1.5s"}
}
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "productHeader__cell d-flex justify-content-center align-items-center bg-white productHeader__cell--shadow installmentImage-c3" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "w-50",
    src: _imports_5,
    alt: ""
  })
], -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "product__backgroundsquare position-absolute" }, null, -1)
const _hoisted_49 = { class: "container p-4 background--darkblue mt-5 product-section" }
const _hoisted_50 = { class: "container-fluid h-100 px-0 px-xl-5 d-flex flex-column justify-content-between" }
const _hoisted_51 = { class: "w-75 text-center mx-auto d-flex flex-column justify-content-center align-items-center" }
const _hoisted_52 = { class: "text-light mt-5 pt-3" }
const _hoisted_53 = { class: "text-secondary my-4" }
const _hoisted_54 = { class: "d-none d-lg-flex productTable row h-50 text-light mb-5 position-relative" }
const _hoisted_55 = { class: "col-3 border-end p-0 pt-5" }
const _hoisted_56 = { class: "pb-5 text-secondary head-min" }
const _hoisted_57 = {
  class: "py-2 border-bottom",
  style: {"font-size":"16px"}
}
const _hoisted_58 = {
  class: "py-2 border-bottom",
  style: {"font-size":"16px"}
}
const _hoisted_59 = {
  class: "py-2 border-bottom",
  style: {"font-size":"16px"}
}
const _hoisted_60 = {
  class: "py-2 border-bottom",
  style: {"font-size":"16px"}
}
const _hoisted_61 = { class: "productTable__box position-absolute h-100 pt-5 ps-4" }
const _hoisted_62 = { class: "pb-4 fw-light head-min" }
const _hoisted_63 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_64 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_65 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_66 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_67 = { class: "productTable__box position-absolute h-100 pt-5 ps-4" }
const _hoisted_68 = { class: "pb-4 fw-light head-min" }
const _hoisted_69 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_70 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_71 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_72 = {
  class: "py-2",
  style: {"font-size":"16px"}
}
const _hoisted_73 = { class: "col-9 p-0 pt-5 z-index-add-300" }
const _hoisted_74 = { class: "pb-5 ps-3 text-secondary head-min" }
const _hoisted_75 = {
  class: "py-2 ps-3 border-bottom fw-light",
  style: {"font-size":"16px"}
}
const _hoisted_76 = {
  class: "py-2 ps-3 border-bottom fw-light",
  style: {"font-size":"16px"}
}
const _hoisted_77 = {
  class: "py-2 ps-3 border-bottom fw-light",
  style: {"font-size":"16px"}
}
const _hoisted_78 = {
  class: "py-2 ps-3 border-bottom fw-light",
  style: {"font-size":"16px"}
}
const _hoisted_79 = { class: "d-block d-lg-none position-relative" }
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "mobileTable__box" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { class: "mobileTable__box" }, null, -1)
const _hoisted_82 = { class: "row productTable--mobile position-relative" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-6 mobileTable__borderRight" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-12 pt-5 px-0 mobileTable__header" }
const _hoisted_87 = { class: "text-secondary" }
const _hoisted_88 = { class: "col-12 px-0" }
const _hoisted_89 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_90 = { class: "col-12 px-0" }
const _hoisted_91 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_92 = { class: "col-12 px-0" }
const _hoisted_93 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_94 = { class: "col-12 px-0" }
const _hoisted_95 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_96 = { class: "col-6" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = { class: "col-12 pt-5 ps-3 ps-5 mobileTable__header" }
const _hoisted_99 = { class: "text-secondary" }
const _hoisted_100 = { class: "col-12 px-0" }
const _hoisted_101 = { class: "text-light py-2 mobileTable__borderBottom ps-3 h-rem-3 h-sm-rem-3" }
const _hoisted_102 = { class: "col-12 px-0" }
const _hoisted_103 = { class: "text-light py-2 mobileTable__borderBottom ps-3 h-rem-3 h-sm-rem-3" }
const _hoisted_104 = { class: "col-12 px-0" }
const _hoisted_105 = { class: "text-light py-2 ps-3  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_106 = { class: "col-12 px-0" }
const _hoisted_107 = { class: "text-light py-2 ps-3  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-6 mobileTable__borderRight" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-12 pt-5 px-0 mobileTable__header" }
const _hoisted_112 = { class: "text-secondary" }
const _hoisted_113 = { class: "col-12 px-0" }
const _hoisted_114 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_115 = { class: "col-12 px-0" }
const _hoisted_116 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_117 = { class: "col-12 px-0" }
const _hoisted_118 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3  " }
const _hoisted_119 = { class: "col-12 px-0" }
const _hoisted_120 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3  " }
const _hoisted_121 = { class: "col-6" }
const _hoisted_122 = { class: "row" }
const _hoisted_123 = { class: "col-12 pt-5 ps-5 ps-5 mobileTable__header text-white" }
const _hoisted_124 = { class: "col-12 px-0" }
const _hoisted_125 = { class: "text-light fw-bold py-2 mobileTable__borderBottom ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_126 = { class: "col-12 px-0" }
const _hoisted_127 = { class: "text-light fw-bold py-2 mobileTable__borderBottom ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_128 = { class: "col-12 px-0" }
const _hoisted_129 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_130 = { class: "col-12 px-0" }
const _hoisted_131 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_132 = { class: "row" }
const _hoisted_133 = { class: "col-6 mobileTable__borderRight" }
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { class: "col-12 pt-5 px-0 mobileTable__header text-white" }
const _hoisted_136 = { class: "text-secondary" }
const _hoisted_137 = { class: "col-12 px-0" }
const _hoisted_138 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_139 = { class: "col-12 px-0" }
const _hoisted_140 = { class: "text-light fw-bold py-2 mobileTable__borderBottom h-rem-3 h-sm-rem-3" }
const _hoisted_141 = { class: "col-12 px-0" }
const _hoisted_142 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_143 = { class: "col-12 px-0" }
const _hoisted_144 = { class: "text-light fw-bold py-2  mobileTable__borderBottom  h-rem-3 h-sm-rem-3" }
const _hoisted_145 = { class: "col-6" }
const _hoisted_146 = { class: "row" }
const _hoisted_147 = { class: "col-12 py-5 ps-5 mobileTable__header text-white" }
const _hoisted_148 = { class: "col-12 px-0" }
const _hoisted_149 = { class: "text-light fw-bold py-2 mobileTable__borderBottom ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_150 = { class: "col-12 px-0" }
const _hoisted_151 = { class: "text-light fw-bold py-2 mobileTable__borderBottom ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_152 = { class: "col-12 px-0" }
const _hoisted_153 = { class: "text-light fw-bold py-2 mobileTable__borderBottom ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_154 = { class: "col-12 px-0" }
const _hoisted_155 = { class: "text-light fw-bold py-2 mobileTable__borderBottom  ps-5 h-rem-3 h-sm-rem-3" }
const _hoisted_156 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, null, -1)
const _hoisted_157 = { class: "container-fluid px-5 pt-5 product-section product-section-steps" }
const _hoisted_158 = { class: "container" }
const _hoisted_159 = { class: "row px-0 px-md-5 pt-5" }
const _hoisted_160 = { style: {"font-size":"36px","line-height":"60px"} }
const _hoisted_161 = {
  class: "text-primary",
  style: {"font-size":"36px"}
}
const _hoisted_162 = /*#__PURE__*/_createVNode("div", { class: "product-section-steps-line" }, null, -1)
const _hoisted_163 = { class: "row px-0 px-md-5 justify-content-between" }
const _hoisted_164 = { class: "col-12 col-md-4 mb-5 mb-md-0" }
const _hoisted_165 = { class: "col-12 h-100 p-4 pt-5 bg-white min-height-card" }
const _hoisted_166 = { class: "row flex-column" }
const _hoisted_167 = /*#__PURE__*/_createVNode("div", { class: "col-12 h-50" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "steps-icon",
    src: _imports_6,
    alt: ""
  })
], -1)
const _hoisted_168 = { class: "col-12 h-50" }
const _hoisted_169 = { class: "mt-5 mb-1 text-dark" }
const _hoisted_170 = { class: "lh-base fw-normal text-dark" }
const _hoisted_171 = { class: "col-12 col-md-4 mb-5 mb-md-0" }
const _hoisted_172 = { class: "col-12 p-4 pt-5 bg-white min-height-card" }
const _hoisted_173 = { class: "row flex-column" }
const _hoisted_174 = /*#__PURE__*/_createVNode("div", { class: "col-12 h-50" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "steps-icon",
    src: _imports_7,
    alt: ""
  })
], -1)
const _hoisted_175 = { class: "col-12 h-50" }
const _hoisted_176 = { class: "mt-5 mb-1 text-dark" }
const _hoisted_177 = { class: "lh-base fw-normal text-dark" }
const _hoisted_178 = { class: "col-12 col-md-4 mb-5 mb-md-0" }
const _hoisted_179 = { class: "col-12 p-4 pt-5 bg-white min-height-card" }
const _hoisted_180 = { class: "row flex-column" }
const _hoisted_181 = /*#__PURE__*/_createVNode("div", { class: "col-12 h-50" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "steps-icon",
    src: _imports_8,
    alt: ""
  })
], -1)
const _hoisted_182 = { class: "col-12 h-50" }
const _hoisted_183 = { class: "mt-5 mb-1 text-dark" }
const _hoisted_184 = { class: "lh-base fw-normal text-dark" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", {
      ref: _ctx.sentinalName,
      class: "productPageHeader text-center text-sm-start"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.t("ProductPage.FinancialFlexibility")), 1),
            _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.t("ProductPage.AtYourFingertips")), 1),
            _createVNode("h5", _hoisted_7, _toDisplayString(_ctx.t("ProductPage.AllYourOnlinePayment")), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_TransitionGroup, {
              name: "fadeLeft",
              tag: "div",
              class: "d-flex flex-column"
            }, {
              default: _withId(() => [
                (_ctx.s1_mastercard)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.s1_visa)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.s1_jcb)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 512),
    _createVNode("div", _hoisted_21, [
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode("h4", _hoisted_27, _toDisplayString(_ctx.t("ProductPage.AcceptForeignCurrency")), 1),
              _createVNode("h6", _hoisted_28, _toDisplayString(_ctx.t("ProductPage.AsWellAsAcceptingPayments")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("h4", _hoisted_32, _toDisplayString(_ctx.t("ProductPage.HighSpeedPaymentProcessing")), 1),
              _hoisted_33,
              _createVNode("h6", _hoisted_34, _toDisplayString(_ctx.t("ProductPage.OurPlatformIsArchitected")), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_35, [
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode("h1", _hoisted_38, [
              _createTextVNode(_toDisplayString(_ctx.t("ProductPage.Installment.bold")) + " ", 1),
              _hoisted_39,
              _createTextVNode(" " + _toDisplayString(_ctx.t("ProductPage.Installment.h1")), 1)
            ]),
            _createVNode("h5", _hoisted_40, _toDisplayString(_ctx.t("ProductPage.Installment.h5")), 1),
            _createVNode("h4", null, _toDisplayString(_ctx.t("ProductPage.Installment.h4")), 1)
          ]),
          _createVNode("div", _hoisted_41, [
            _createVNode(_TransitionGroup, {
              name: "fadeLeft",
              tag: "div",
              class: "d-flex flex-column"
            }, {
              default: _withId(() => [
                (_ctx.s2_firstchoice)
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _hoisted_43
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.s2_ktc)
                  ? (_openBlock(), _createBlock("div", _hoisted_44, [
                      _hoisted_45
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.s2_krungsri)
                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                      _hoisted_47
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _hoisted_48
          ], 512)
        ])
      ]),
      _createVNode("div", _hoisted_49, [
        _createVNode("div", _hoisted_50, [
          _createVNode("div", _hoisted_51, [
            _createVNode("h1", _hoisted_52, _toDisplayString(_ctx.t("ProductPage.MonthlyPaymentOptions")), 1),
            _createVNode("h6", _hoisted_53, _toDisplayString(_ctx.t("ProductPage.OfferFlexiblePayment")), 1)
          ]),
          _createVNode("div", _hoisted_54, [
            _createVNode("div", _hoisted_55, [
              _createVNode("h6", _hoisted_56, _toDisplayString(_ctx.t("ProductPage.CardBrand")), 1),
              _createVNode("h5", _hoisted_57, _toDisplayString(_ctx.t("ProductPage.KTC")), 1),
              _createVNode("h5", _hoisted_58, _toDisplayString(_ctx.t("ProductPage.KrungsriFirstChoice")), 1),
              _createVNode("h5", _hoisted_59, _toDisplayString(_ctx.t("ProductPage.KrungsriCard")), 1),
              _createVNode("h5", _hoisted_60, _toDisplayString(_ctx.t("ProductPage.BangkokBank")), 1)
            ]),
            _createVNode("div", _hoisted_61, [
              _createVNode("h6", _hoisted_62, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.text1")), 1),
              _createVNode("h5", _hoisted_63, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KTC")), 1),
              _createVNode("h5", _hoisted_64, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KrungsriFirstChoice")), 1),
              _createVNode("h5", _hoisted_65, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KrungsriCard")), 1),
              _createVNode("h5", _hoisted_66, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.BangkokBank")), 1)
            ]),
            _createVNode("div", _hoisted_67, [
              _createVNode("h6", _hoisted_68, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.text")), 1),
              _createVNode("h5", _hoisted_69, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KTC")), 1),
              _createVNode("h5", _hoisted_70, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KrungsriFirstChoice")), 1),
              _createVNode("h5", _hoisted_71, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KrungsriCard")), 1),
              _createVNode("h5", _hoisted_72, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.BangkokBank")), 1)
            ]),
            _createVNode("div", _hoisted_73, [
              _createVNode("h6", _hoisted_74, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.text")), 1),
              _createVNode("h5", _hoisted_75, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KTC")), 1),
              _createVNode("h5", _hoisted_76, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KrungsriFirstChoice")), 1),
              _createVNode("h5", _hoisted_77, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KrungsriCard")), 1),
              _createVNode("h5", _hoisted_78, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.BangkokBank")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_79, [
            _hoisted_80,
            _hoisted_81,
            _createVNode("div", _hoisted_82, [
              _createVNode("div", _hoisted_83, [
                _createVNode("div", _hoisted_84, [
                  _createVNode("div", _hoisted_85, [
                    _createVNode("div", _hoisted_86, [
                      _createVNode("p", _hoisted_87, _toDisplayString(_ctx.t("ProductPage.CardBrand")), 1)
                    ]),
                    _createVNode("div", _hoisted_88, [
                      _createVNode("p", _hoisted_89, _toDisplayString(_ctx.t("ProductPage.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_90, [
                      _createVNode("p", _hoisted_91, _toDisplayString(_ctx.t("ProductPage.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_92, [
                      _createVNode("p", _hoisted_93, _toDisplayString(_ctx.t("ProductPage.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_94, [
                      _createVNode("p", _hoisted_95, _toDisplayString(_ctx.t("ProductPage.BangkokBank")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_96, [
                  _createVNode("div", _hoisted_97, [
                    _createVNode("div", _hoisted_98, [
                      _createVNode("p", _hoisted_99, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.text")), 1)
                    ]),
                    _createVNode("div", _hoisted_100, [
                      _createVNode("p", _hoisted_101, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_102, [
                      _createVNode("p", _hoisted_103, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_104, [
                      _createVNode("p", _hoisted_105, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_106, [
                      _createVNode("p", _hoisted_107, _toDisplayString(_ctx.t("ProductPage.InstallmentTermLengths.BangkokBank")), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_108, [
                _createVNode("div", _hoisted_109, [
                  _createVNode("div", _hoisted_110, [
                    _createVNode("div", _hoisted_111, [
                      _createVNode("p", _hoisted_112, _toDisplayString(_ctx.t("ProductPage.CardBrand")), 1)
                    ]),
                    _createVNode("div", _hoisted_113, [
                      _createVNode("p", _hoisted_114, _toDisplayString(_ctx.t("ProductPage.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_115, [
                      _createVNode("p", _hoisted_116, _toDisplayString(_ctx.t("ProductPage.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_117, [
                      _createVNode("p", _hoisted_118, _toDisplayString(_ctx.t("ProductPage.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_119, [
                      _createVNode("p", _hoisted_120, _toDisplayString(_ctx.t("ProductPage.BangkokBank")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_121, [
                  _createVNode("div", _hoisted_122, [
                    _createVNode("div", _hoisted_123, [
                      _createVNode("p", null, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.text1")), 1)
                    ]),
                    _createVNode("div", _hoisted_124, [
                      _createVNode("p", _hoisted_125, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_126, [
                      _createVNode("p", _hoisted_127, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_128, [
                      _createVNode("p", _hoisted_129, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_130, [
                      _createVNode("p", _hoisted_131, _toDisplayString(_ctx.t("ProductPage.MonthlyMinimum.BangkokBank")), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_132, [
                _createVNode("div", _hoisted_133, [
                  _createVNode("div", _hoisted_134, [
                    _createVNode("div", _hoisted_135, [
                      _createVNode("p", _hoisted_136, _toDisplayString(_ctx.t("ProductPage.CardBrand")), 1)
                    ]),
                    _createVNode("div", _hoisted_137, [
                      _createVNode("p", _hoisted_138, _toDisplayString(_ctx.t("ProductPage.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_139, [
                      _createVNode("p", _hoisted_140, _toDisplayString(_ctx.t("ProductPage.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_141, [
                      _createVNode("p", _hoisted_142, _toDisplayString(_ctx.t("ProductPage.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_143, [
                      _createVNode("p", _hoisted_144, _toDisplayString(_ctx.t("ProductPage.BangkokBank")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_145, [
                  _createVNode("div", _hoisted_146, [
                    _createVNode("div", _hoisted_147, [
                      _createVNode("p", null, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.text")), 1)
                    ]),
                    _createVNode("div", _hoisted_148, [
                      _createVNode("p", _hoisted_149, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KTC")), 1)
                    ]),
                    _createVNode("div", _hoisted_150, [
                      _createVNode("p", _hoisted_151, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KrungsriFirstChoice")), 1)
                    ]),
                    _createVNode("div", _hoisted_152, [
                      _createVNode("p", _hoisted_153, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.KrungsriCard")), 1)
                    ]),
                    _createVNode("div", _hoisted_154, [
                      _createVNode("p", _hoisted_155, _toDisplayString(_ctx.t("ProductPage.InterestAbsorbedCustomer.BangkokBank")), 1)
                    ])
                  ])
                ])
              ]),
              _hoisted_156
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_157, [
        _createVNode("div", _hoisted_158, [
          _createVNode("div", _hoisted_159, [
            _createVNode("h1", _hoisted_160, _toDisplayString(_ctx.t("ProductPage.GetPaidIn")), 1),
            _createVNode("h1", _hoisted_161, _toDisplayString(_ctx.t("ProductPage.3simpleSteps")), 1),
            _hoisted_162
          ]),
          _createVNode("div", _hoisted_163, [
            _createVNode("div", _hoisted_164, [
              _createVNode("div", _hoisted_165, [
                _createVNode("div", _hoisted_166, [
                  _hoisted_167,
                  _createVNode("div", _hoisted_168, [
                    _createVNode("h5", _hoisted_169, [
                      _createVNode("strong", null, _toDisplayString(_ctx.t("ProductPage.UserScansOrUploadsTheQR")), 1)
                    ]),
                    _createVNode("h5", _hoisted_170, _toDisplayString(_ctx.t("ProductPage.TheUserScansOrUploads")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_171, [
              _createVNode("div", _hoisted_172, [
                _createVNode("div", _hoisted_173, [
                  _hoisted_174,
                  _createVNode("div", _hoisted_175, [
                    _createVNode("h5", _hoisted_176, [
                      _createVNode("strong", null, _toDisplayString(_ctx.t("ProductPage.UserConfirmsPayment")), 1)
                    ]),
                    _createVNode("h5", _hoisted_177, _toDisplayString(_ctx.t("ProductPage.TheUserVerifies")), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_178, [
              _createVNode("div", _hoisted_179, [
                _createVNode("div", _hoisted_180, [
                  _hoisted_181,
                  _createVNode("div", _hoisted_182, [
                    _createVNode("h5", _hoisted_183, [
                      _createVNode("strong", null, _toDisplayString(_ctx.t("ProductPage.YouReceiveFunds")), 1)
                    ]),
                    _createVNode("h5", _hoisted_184, _toDisplayString(_ctx.t("ProductPage.FundsAreInstantly")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})